import { useEffect } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Routes, Route, Navigate } from "react-router-dom";
import { TooltipProvider } from "../../ui/tooltip";
import "../../assets/css/UnderwritingExceptions/style.css";

// @ts-ignore
import Header from "../../components/Header";
// @ts-ignore
import RightAside from "../../components/RightAside";
// @ts-ignore
import UserService from "../../services/UserService";

import { UnderwritingHealth } from "./pages/UnderwritingHealth";
import { ExceptionsLog } from "./pages/ExceptionsLog";
import { ExceptionsOverrides } from "./pages/ExceptionsOverrides";
import { PolicyCompliance } from "./pages/PolicyCompliance";
import { AgreementCulture } from "./pages/AgreementCulture";
import { DealerQuality } from "./pages/DealerQuality";
import { Productivity } from "./pages/Productivity";
import { ManageAlerts } from "./pages/ManageAlerts";
import { ManageOfficeRollout } from "./pages/ManageOfficeRollout";

const queryClient = new QueryClient();

function UnderwritingExceptionsInner() {
  useEffect(() => {
    document.body.classList.add("underwriting-exceptions-active");
    return () => document.body.classList.remove("underwriting-exceptions-active");
  }, []);

  // shadcn/Radix render Select menus, Dialogs and Popovers through a portal attached to <body>,
  // which sits outside .underwriting-exceptions-theme. Tokens scoped only to that wrapper never
  // reached them, so dropdown items and dialog inputs fell back to the app's default light
  // --popover-foreground and drew black text on a dark surface. Putting the class and `dark` on
  // <html> while this product is mounted covers portal content too. AthenaPricingEngine.tsx does
  // exactly this for the same reason.
  useEffect(() => {
    const root = document.documentElement;
    root.classList.add("underwriting-exceptions-root", "dark");
    return () => root.classList.remove("underwriting-exceptions-root", "dark");
  }, []);

  const token = UserService.getToken();

  return (
    <div className="underwriting-exceptions-theme">
      <Header
        token={token}
        isMarketplacePage={false}
        notificationsCount={0}
        refreshNotifications={() => {}}
        setIndustry={() => {}}
        setCompany={() => {}}
        leftNode={null}
        productLabel="Underwriting Exceptions & Performance"
        fixed={true}
      />
      <Routes>
        <Route index element={<UnderwritingHealth />} />
        <Route path="productivity" element={<Productivity />} />
        <Route path="exceptions-overrides" element={<ExceptionsOverrides />} />
        <Route path="policy-compliance" element={<PolicyCompliance />} />
        <Route path="exceptions-log" element={<ExceptionsLog />} />
        <Route path="dealer-quality" element={<DealerQuality />} />
        <Route path="agreement-culture" element={<AgreementCulture />} />
        <Route path="manage-alerts" element={<ManageAlerts />} />
        <Route path="manage-office-rollout" element={<ManageOfficeRollout />} />
        <Route path="*" element={<Navigate to="/underwriting-exceptions" replace />} />
      </Routes>
      <RightAside showChildrenWhenNoPanel={false}>{null}</RightAside>
    </div>
  );
}

export default function UnderwritingExceptions() {
  return (
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <UnderwritingExceptionsInner />
      </TooltipProvider>
    </QueryClientProvider>
  );
}
